import { fetchBaseQuery } from '@reduxjs/toolkit/query/react';

const BASE_URL = `https://api.useplunk.com/v1/track`

export const baseQuery = fetchBaseQuery({
    baseUrl: BASE_URL,
    prepareHeaders: (headers) => {
        headers.set('Authorization', `Bearer ${process.env.REACT_APP_PLUNK_PUBLIC_KEY}`);

        return headers;
    },
});